import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#2C3E50] text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Column 1 - Company Info */}
          <div className="space-y-4">
            <img 
              src="https://static.readdy.ai/image/e4c5981b2fc547acaa3ea617440dd341/f8967550c751d2f546343067113c7808.png" 
              alt="Nakhalat Finance" 
              className="h-20 w-auto brightness-0 invert"
            />
            <p className="text-sm leading-relaxed">
              Empowering Growth Through Financial Inclusion.
            </p>
            <div className="flex items-center gap-2 text-xs bg-white/10 px-3 py-2 rounded-md inline-block">
              <i className="ri-shield-check-line text-[#14B8A6]"></i>
              <span>Licensed & Regulated by RBZ</span>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-white text-sm font-semibold uppercase tracking-wider mb-4">
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm hover:text-white transition-colors cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/loans" className="text-sm hover:text-white transition-colors cursor-pointer">
                  Loan Products
                </Link>
              </li>
              <li>
                <Link to="/apply" className="text-sm hover:text-white transition-colors cursor-pointer">
                  How to Apply
                </Link>
              </li>
              <li>
                <Link to="/customer-protection" className="text-sm hover:text-white transition-colors cursor-pointer">
                  Customer Protection
                </Link>
              </li>
              <li>
                <Link to="/complaints" className="text-sm hover:text-white transition-colors cursor-pointer">
                  Complaints Process
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm hover:text-white transition-colors cursor-pointer">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 - Contact Information */}
          <div>
            <h3 className="text-white text-sm font-semibold uppercase tracking-wider mb-4">
              Contact Information
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#14B8A6] mt-1"></i>
                <span className="text-sm">
                  56 Edmonds Ave, Belvedere, Harare, Zimbabwe
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-[#14B8A6]"></i>
                <a href="tel:+263782251180" className="text-sm hover:text-white transition-colors cursor-pointer">
                  +263 78 225 1180
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-[#14B8A6]"></i>
                <a href="mailto:apply@nakhalatfinance.com" className="text-sm hover:text-white transition-colors cursor-pointer">
                  apply@nakhalatfinance.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-[#14B8A6] mt-1"></i>
                <span className="text-sm">
                  Mon - Fri: 8:00 AM - 5:00 PM<br />
                  Sat: 8:00 AM - 1:00 PM
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Lower Footer */}
        <div className="mt-12 pt-8 border-t border-gray-600">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400 text-center md:text-left">
              © 2025 Nakhalat Finance (Private) Limited. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
          <p className="text-xs text-gray-500 mt-4 text-center">
            This website is for informational purposes only and does not constitute a public offer.
          </p>
        </div>
      </div>
    </footer>
  );
}